import { useRef, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { TrackingView } from './tracking-view';
import { TrackingPhone } from './tracking-phone';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import trackingForms from 'src/api/tracking/vm-form';
import useToast from 'src/utils/toast-utils';
import { useCallbackAction } from 'src/hooks/use-actions';
import PageSection from 'src/layouts/page-section';
import useDeviceView from 'src/hooks/use-device-view';

const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const childRef = useRef();
  const [nextStep, setNextStep] = useState({});
  const { useCompactLayout } = useDeviceView();

  const { createStudentTracking, updateStudentTracking, deleteStudentTracking } = trackingForms();
  const { toastSuccess, toastError } = useToast();
  
  const apiCreate = (values) => useCallbackAction(createStudentTracking, values, 
      (result) => {
        toastSuccess(`Đã thêm: ${result?.trackingName}`);
        childRef.current?.addTracking(result);
      }, toastError);

  const apiUpdate = (values) => useCallbackAction(updateStudentTracking, values, 
      (result) => {
        toastSuccess(`Đã sửa: ${result?.trackingName}`);
        childRef.current?.reloadItem(result);
      }, toastError);
  
  const apiDelete = (values) => useCallbackAction(deleteStudentTracking, values, 
      (result) => {
        toastSuccess(`Đã xóa: ${result?.trackingId}`);
        childRef.current?.removeTracking(result);
      }, toastError);

  return (
    <PageSection title="Tracking" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.students)}
          subLabel={item?.code}
          extraContent={
            !useCompactLayout && (
              <Stack direction="row" alignItems="center">
                <Typography variant="subtitle2" color="primary" sx={{ mr: 2 }}>
                  {nextStep.trackingLabel}
                </Typography>

                <Typography variant="body2" color="text.primary">
                  {nextStep.statusLabel}
                </Typography>
              </Stack>
            )
          }
        />
        {useCompactLayout ? (
          <TrackingPhone
            ref={childRef}
            item={item}
          />
        ) : (
          <TrackingView
            ref={childRef}
            item={item}
            apiCreate={apiCreate}
            apiUpdate={apiUpdate}
            apiDelete={apiDelete}
            onNextStep={(val) => {
              setNextStep(val);
            }}
          />
        )}
      </Stack>
    </PageSection>
  );
};

export default Page;
